// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   CONTAINER FLEX CONTEXT
   Both \`.for-loop-started\` and \`.contentWraps\` are column stacks
   whose children are laid out by flex — this eliminates the
   whitespace text nodes between rows.
   ============================================================ */
.for-loop-started,
.contentWraps {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Direct div children must also be flex containers so whitespace
   between their own children collapses. Default direction is row
   (that's what key / separator / value need), but iteration
   wrappers override it to column below.
   ------------------------------------------------------------ */
.for-loop-started > div,
.contentWraps > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.for-loop-started .loop-phase-badge {
   left: 0;
   top: -14px;
}
/* Iteration wrappers stack their rows vertically, not horizontally */
.for-loop-started > [data-iter-id],
.contentWraps > [data-iter-id] {
  flex-direction: column;
  align-items: stretch;
  flex-wrap: nowrap;
  width: 98%;
}

/* ============================================================
   CARD MODE — applied by applyCardsToWrappedLoop.
   Base container + direction modifier classes are added on the
   loop container (\`for-loop-started\`), iteration wrappers get
   \`.previewCard\`.
   ============================================================ */
.for-loop-started.previewCardContainer {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Direction: vertical (column, scrolls on Y) */
.for-loop-started.previewCardContainer.previewCardContainerVertical {
  flex-direction: column;
  flex-wrap: nowrap;
}

/* Direction: horizontal (row, wraps, scrolls on X)
   Placed AFTER the vertical rule so it wins on specificity tie
   when both direction classes somehow coexist. */
.for-loop-started.previewCardContainer.previewCardContainerHorizontal {
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: auto;
}

/* Per-iteration card styling */
.for-loop-started.previewCardContainer > [data-iter-id].previewCard {
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* In horizontal mode, give each card a sensible min/max width so
   they wrap nicely instead of stretching to fill the row. */
.for-loop-started.previewCardContainer.previewCardContainerHorizontal
  > [data-iter-id].previewCard {
  flex: 0 1 auto;
  min-width: 260px;
  max-width: 400px;
}

/* ============================================================
   ROW — a horizontal flex line.
   A row may contain multiple direct children (key, separator,
   value), so it needs display:flex with flex-direction:row.
   ============================================================ */
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 4px 8px;
  margin: 2px 0;
  line-height: 1.5;
  border-radius: 4px;
  font-size: 14px;
  color: #2d3748;
}

.contentWraps {
  display: flex;
  flex-direction: column;
}
.contentWraps .text-center {
  justify-content: center;
}
.contentWraps .text-right {
  justify-content: flex-end;
}
.contentWraps .text-left {
  justify-content: flex-start;
}

/* Base class for visual cue - applied via JS only during structural transformation phase */
.item-ui-screen[data-item-ui-index="0"] .for-loop-started.loop-phase-active {
  background-color: #fff7ed; /* Light orange (Tailwind's orange-50) */
  border-radius: 4px;
  padding: 4px 8px;
  margin: 4px 0;
  /* NO BORDERS as requested */
  transition: background-color 0.2s ease;
  background-color: transparent;
}

/* If there are multiple for-loops on the first screen, use nth-child to darken them slightly */
.item-ui-screen[data-item-ui-index="0"]
  .for-loop-started.loop-phase-active:nth-of-type(2) {
  background-color: #ffedd5; /* Slightly darker (orange-100) */
}

.item-ui-screen[data-item-ui-index="0"]
  .for-loop-started.loop-phase-active:nth-of-type(3) {
  background-color: #fed7aa; /* Even darker (orange-200) */
}

/* (Optional) A hover effect to show it's interactive/selectable */
.item-ui-screen[data-item-ui-index="0"]
  .for-loop-started.loop-phase-active:hover {
  background-color: #ffedd5; /* orange-100 */
  cursor: pointer;
  background-color: transparent;
}
.loop-phase-active .row {
  border-bottom: 1px solid rgb(221, 221, 221) ;
  border-radius: 0px;
  padding: 0px 20px;
}
.item-ui-screen {
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-height: 100%;
  overflow: auto;
  -webkit-user-select: text;
          user-select: text;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: monospace;
  font-size: 14px;
  line-height: 1.8;
}
.array-layout-container {
  display: flex;
  gap: 12px;
  box-sizing: border-box;
  overflow: auto;
  /* width: 100%; */
}

.array-layout-vertical {
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 700px;
  margin: 16px;
}
.array-layout-horizontal {
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 16px;
  padding: 8px 16px;
  align-items: stretch;
  min-height: 200px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0px;
}

.array-layout-horizontal::-webkit-scrollbar {
  height: 8px;
}

.array-layout-horizontal::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.array-layout-horizontal::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.array-layout-horizontal::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.array-layout-horizontal .item-ui-screen {
  flex: 0 0 350px;
  min-width: 250px;
  max-width: 400px;
  box-sizing: border-box;
  margin-bottom: 0;
  display: inline-block;
}

.array-layout-vertical .item-ui-screen {
  flex: 0 0 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: block;
}
.array-layout-horizontal::after {
  content: "";
  flex: 0 0 4px;
}
@media (max-width: 768px) {
  .array-layout-horizontal {
    flex-wrap: wrap;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 600px;
  }
  .array-layout-horizontal .item-ui-screen {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: unset;
  }
}

/* Optional: Customize number of columns */
.array-layout-horizontal.columns-2 .item-ui-screen {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 12px);
  max-width: calc(50% - 12px);
}

.array-layout-horizontal.columns-3 .item-ui-screen {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(33.333% - 12px);
  max-width: calc(33.333% - 12px);
}

.array-layout-horizontal.columns-4 .item-ui-screen {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(25% - 12px);
  max-width: calc(25% - 12px);
}

/* Button rows */
.row.button {
  display: flex;
  padding: 8px 16px;
  background: linear-gradient(135deg, #4a7feb, #3b6bd4);
  color: white !important;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  margin: 4px 0;
  box-shadow: 0 2px 8px rgba(74, 127, 235, 0.25);
  align-content: center;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-top: 20px;
}

.row.button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(74, 127, 235, 0.35);
  background: linear-gradient(135deg, #3b6bd4, #2a5fcc);
}

.row.button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(74, 127, 235, 0.2);
}

/* Row variations from transformations */

.row.bold {
  font-weight: 700;
}

.row.italic {
  font-style: italic;
}

.row.underline {
  text-decoration: underline;
}

.row.strikethrough {
  text-decoration: line-through;
}

/* Key-value pairs inside rows */
.row .key {
  font-weight: 500;
  color: #2d3748;
}

.row .value {
  color: #4a5568;
}

.row .separator {
  color: #a0aec0;
  margin: 0 4px;
}

/* Section headers */
.row .section-header {
  font-weight: 700;
  font-size: 16px;
  color: #1a202c;
  display: block;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 4px;
  margin-bottom: 8px;
}

/* Image URLs */
.row .value.image-url {
  color: #4a7feb;
  cursor: pointer;
  text-decoration: underline;
}

.row .value.image-url:hover {
  color: #2a5fcc;
}

/* Empty lines */
.row.empty-line {
  height: 6px;
  min-height: 6px;
}

/* Alternating row colors (optional) */
.row:nth-child(even) {
  background-color: #f8fafc;
}

.row:nth-child(odd) {
  background-color: #ffffff;
}

/* Responsive */
@media (max-width: 768px) {
  .row {
    padding: 6px 10px;
    font-size: 13px;
  }

  .row.button {
    padding: 10px 16px;
    width: 100%;
    text-align: center;
  }
}

.highlight {
  background-color: #fef3c7;
  /* border-left: 4px solid #f59e0b; */
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 500;
}
.row.highlight {
  background-color: #fef3c7;
  /* border-left: 4px solid #f59e0b; */
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 500;
}
.row .key.bold {
  color: #4a5568;
  font-weight: 600;
}
.row .key.italic {
  font-style: italic;
}

.faq-form-statement {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background-color: rgb(240, 247, 255);
  border-left: 4px solid rgb(74, 127, 235);
  border-radius: 4px;
  font-size: 14px;
  color: rgb(51, 51, 51);
  line-height: 1.5;
}

.faq-form-statement span:first-child {
  font-size: 16px;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/transformationRenderer.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;AACjE;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;;iEAIiE;AACjE;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;GACG,OAAO;GACP,UAAU;AACb;AACA,qEAAqE;AACrE;;EAEE,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;;;;iEAKiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;iDAEiD;AACjD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;4DAC4D;AAC5D;;EAEE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;iEAIiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;;AAEA,2FAA2F;AAC3F;EACE,yBAAyB,EAAE,wCAAwC;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA,+FAA+F;AAC/F;;EAEE,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA;;EAEE,yBAAyB,EAAE,6BAA6B;AAC1D;;AAEA,kEAAkE;AAClE;;EAEE,yBAAyB,EAAE,eAAe;EAC1C,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,0CAA0C;AAC1C;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAA8B;EAA9B,cAA8B;EAA9B,gCAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,iBAAiB;EACjB,qDAAqD;EACrD,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8CAA8C;EAC9C,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,wCAAwC;;AAExC;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* ============================================================\n   CONTAINER FLEX CONTEXT\n   Both `.for-loop-started` and `.contentWraps` are column stacks\n   whose children are laid out by flex — this eliminates the\n   whitespace text nodes between rows.\n   ============================================================ */\n.for-loop-started,\n.contentWraps {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* Direct div children must also be flex containers so whitespace\n   between their own children collapses. Default direction is row\n   (that's what key / separator / value need), but iteration\n   wrappers override it to column below.\n   ------------------------------------------------------------ */\n.for-loop-started > div,\n.contentWraps > div {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.for-loop-started .loop-phase-badge {\n   left: 0;\n   top: -14px;\n}\n/* Iteration wrappers stack their rows vertically, not horizontally */\n.for-loop-started > [data-iter-id],\n.contentWraps > [data-iter-id] {\n  flex-direction: column;\n  align-items: stretch;\n  flex-wrap: nowrap;\n  width: 98%;\n}\n\n/* ============================================================\n   CARD MODE — applied by applyCardsToWrappedLoop.\n   Base container + direction modifier classes are added on the\n   loop container (`for-loop-started`), iteration wrappers get\n   `.previewCard`.\n   ============================================================ */\n.for-loop-started.previewCardContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Direction: vertical (column, scrolls on Y) */\n.for-loop-started.previewCardContainer.previewCardContainerVertical {\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n/* Direction: horizontal (row, wraps, scrolls on X)\n   Placed AFTER the vertical rule so it wins on specificity tie\n   when both direction classes somehow coexist. */\n.for-loop-started.previewCardContainer.previewCardContainerHorizontal {\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  overflow-x: auto;\n}\n\n/* Per-iteration card styling */\n.for-loop-started.previewCardContainer > [data-iter-id].previewCard {\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* In horizontal mode, give each card a sensible min/max width so\n   they wrap nicely instead of stretching to fill the row. */\n.for-loop-started.previewCardContainer.previewCardContainerHorizontal\n  > [data-iter-id].previewCard {\n  flex: 0 1 auto;\n  min-width: 260px;\n  max-width: 400px;\n}\n\n/* ============================================================\n   ROW — a horizontal flex line.\n   A row may contain multiple direct children (key, separator,\n   value), so it needs display:flex with flex-direction:row.\n   ============================================================ */\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n  padding: 4px 8px;\n  margin: 2px 0;\n  line-height: 1.5;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #2d3748;\n}\n\n.contentWraps {\n  display: flex;\n  flex-direction: column;\n}\n.contentWraps .text-center {\n  justify-content: center;\n}\n.contentWraps .text-right {\n  justify-content: flex-end;\n}\n.contentWraps .text-left {\n  justify-content: flex-start;\n}\n\n/* Base class for visual cue - applied via JS only during structural transformation phase */\n.item-ui-screen[data-item-ui-index=\"0\"] .for-loop-started.loop-phase-active {\n  background-color: #fff7ed; /* Light orange (Tailwind's orange-50) */\n  border-radius: 4px;\n  padding: 4px 8px;\n  margin: 4px 0;\n  /* NO BORDERS as requested */\n  transition: background-color 0.2s ease;\n  background-color: transparent;\n}\n\n/* If there are multiple for-loops on the first screen, use nth-child to darken them slightly */\n.item-ui-screen[data-item-ui-index=\"0\"]\n  .for-loop-started.loop-phase-active:nth-of-type(2) {\n  background-color: #ffedd5; /* Slightly darker (orange-100) */\n}\n\n.item-ui-screen[data-item-ui-index=\"0\"]\n  .for-loop-started.loop-phase-active:nth-of-type(3) {\n  background-color: #fed7aa; /* Even darker (orange-200) */\n}\n\n/* (Optional) A hover effect to show it's interactive/selectable */\n.item-ui-screen[data-item-ui-index=\"0\"]\n  .for-loop-started.loop-phase-active:hover {\n  background-color: #ffedd5; /* orange-100 */\n  cursor: pointer;\n  background-color: transparent;\n}\n.loop-phase-active .row {\n  border-bottom: 1px solid rgb(221, 221, 221) ;\n  border-radius: 0px;\n  padding: 0px 20px;\n}\n.item-ui-screen {\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  padding: 16px;\n  margin-bottom: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-height: 100%;\n  overflow: auto;\n  user-select: text;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-family: monospace;\n  font-size: 14px;\n  line-height: 1.8;\n}\n.array-layout-container {\n  display: flex;\n  gap: 12px;\n  box-sizing: border-box;\n  overflow: auto;\n  /* width: 100%; */\n}\n\n.array-layout-vertical {\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 700px;\n  margin: 16px;\n}\n.array-layout-horizontal {\n  flex-direction: row;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n  gap: 16px;\n  padding: 8px 16px;\n  align-items: stretch;\n  min-height: 200px;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: 0px;\n}\n\n.array-layout-horizontal::-webkit-scrollbar {\n  height: 8px;\n}\n\n.array-layout-horizontal::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.array-layout-horizontal::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.array-layout-horizontal::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.array-layout-horizontal .item-ui-screen {\n  flex: 0 0 350px;\n  min-width: 250px;\n  max-width: 400px;\n  box-sizing: border-box;\n  margin-bottom: 0;\n  display: inline-block;\n}\n\n.array-layout-vertical .item-ui-screen {\n  flex: 0 0 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  display: block;\n}\n.array-layout-horizontal::after {\n  content: \"\";\n  flex: 0 0 4px;\n}\n@media (max-width: 768px) {\n  .array-layout-horizontal {\n    flex-wrap: wrap;\n    overflow-x: hidden;\n    overflow-y: auto;\n    max-height: 600px;\n  }\n  .array-layout-horizontal .item-ui-screen {\n    flex: 0 0 100%;\n    max-width: 100%;\n    min-width: unset;\n  }\n}\n\n/* Optional: Customize number of columns */\n.array-layout-horizontal.columns-2 .item-ui-screen {\n  flex: 0 0 calc(50% - 12px);\n  max-width: calc(50% - 12px);\n}\n\n.array-layout-horizontal.columns-3 .item-ui-screen {\n  flex: 0 0 calc(33.333% - 12px);\n  max-width: calc(33.333% - 12px);\n}\n\n.array-layout-horizontal.columns-4 .item-ui-screen {\n  flex: 0 0 calc(25% - 12px);\n  max-width: calc(25% - 12px);\n}\n\n/* Button rows */\n.row.button {\n  display: flex;\n  padding: 8px 16px;\n  background: linear-gradient(135deg, #4a7feb, #3b6bd4);\n  color: white !important;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  margin: 4px 0;\n  box-shadow: 0 2px 8px rgba(74, 127, 235, 0.25);\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.row.button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(74, 127, 235, 0.35);\n  background: linear-gradient(135deg, #3b6bd4, #2a5fcc);\n}\n\n.row.button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(74, 127, 235, 0.2);\n}\n\n/* Row variations from transformations */\n\n.row.bold {\n  font-weight: 700;\n}\n\n.row.italic {\n  font-style: italic;\n}\n\n.row.underline {\n  text-decoration: underline;\n}\n\n.row.strikethrough {\n  text-decoration: line-through;\n}\n\n/* Key-value pairs inside rows */\n.row .key {\n  font-weight: 500;\n  color: #2d3748;\n}\n\n.row .value {\n  color: #4a5568;\n}\n\n.row .separator {\n  color: #a0aec0;\n  margin: 0 4px;\n}\n\n/* Section headers */\n.row .section-header {\n  font-weight: 700;\n  font-size: 16px;\n  color: #1a202c;\n  display: block;\n  border-bottom: 2px solid #e2e8f0;\n  padding-bottom: 4px;\n  margin-bottom: 8px;\n}\n\n/* Image URLs */\n.row .value.image-url {\n  color: #4a7feb;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.row .value.image-url:hover {\n  color: #2a5fcc;\n}\n\n/* Empty lines */\n.row.empty-line {\n  height: 6px;\n  min-height: 6px;\n}\n\n/* Alternating row colors (optional) */\n.row:nth-child(even) {\n  background-color: #f8fafc;\n}\n\n.row:nth-child(odd) {\n  background-color: #ffffff;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .row {\n    padding: 6px 10px;\n    font-size: 13px;\n  }\n\n  .row.button {\n    padding: 10px 16px;\n    width: 100%;\n    text-align: center;\n  }\n}\n\n.highlight {\n  background-color: #fef3c7;\n  /* border-left: 4px solid #f59e0b; */\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-weight: 500;\n}\n.row.highlight {\n  background-color: #fef3c7;\n  /* border-left: 4px solid #f59e0b; */\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-weight: 500;\n}\n.row .key.bold {\n  color: #4a5568;\n  font-weight: 600;\n}\n.row .key.italic {\n  font-style: italic;\n}\n\n.faq-form-statement {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  background-color: rgb(240, 247, 255);\n  border-left: 4px solid rgb(74, 127, 235);\n  border-radius: 4px;\n  font-size: 14px;\n  color: rgb(51, 51, 51);\n  line-height: 1.5;\n}\n\n.faq-form-statement span:first-child {\n  font-size: 16px;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
